import {
    MEMBER_ROLE
  } from "../constant/user";
  
const initialState = {
  memberDetails: []
};


const MemberDetailReducer = (state=initialState,action)=>{
    const { type, payload } = action;
    switch(type){
        case MEMBER_ROLE:
            return {...state, memberDetails: payload }
        default:
            return state;
    }
}

export default MemberDetailReducer;